import type { AccountType } from '../api/resources/accounts/types';

type PendoVisitor = {
  id: string;
  environment: string;
  region: string;
  userType: string;
  project_id?: string;
  account_type?: AccountType;
  isPlg?: boolean;
  tags?: string[];
};

type PendoAccount = {
  id: string;
};

export const loadPendoScript = (apiKey: string) => {
  if (typeof window === 'undefined' || (window as any).pendo) {
    return;
  }

  (function (p: any, e: Document, n: string, d: string) {
    // Set up the pendo object
    const o = (p[d] = p[d] || {});
    o._q = o._q || [];
    const v = [
      'initialize',
      'identify',
      'updateOptions',
      'pageLoad',
      'track',
      'getVisitor',
      'getAccount',
    ];
    for (let w = 0, x = v.length; w < x; ++w) {
      const m = v[w];
      o[m] =
        o[m] ||
        function (...args: any[]) {
          o._q[m === v[0] ? 'unshift' : 'push']([m, ...args]);
        };
    }

    const y = e.createElement(n) as HTMLScriptElement;
    y.async = true;
    y.src = `https://content.polyai.app/agent/static/${apiKey}/pendo.js`;
    const z = e.getElementsByTagName(n)[0];
    if (z && z.parentNode) {
      z.parentNode.insertBefore(y, z);
    }
  })(window, document, 'script', 'pendo');
};

const initializePendo = (
  visitor: PendoVisitor,
  appKey: string,
  account?: PendoAccount,
) => {
  loadPendoScript(appKey);
  window.pendo.initialize({
    apiKey: appKey,
    visitor,
    ...(account && { account }),
  });
};

export const updatePendo = (
  appKey: string,
  visitor: PendoVisitor,
  account?: PendoAccount,
) => {
  if (!window.pendo) {
    initializePendo(visitor, appKey, account);
    return;
  }
  window.pendo.updateOptions({
    visitor: visitor,
    ...(account && { account }),
  });
};

// Track custom Pendo events
export const trackPendoEvent = (
  eventName: string,
  metadata?: Record<string, any>,
) => {
  if (window.pendo?.track) {
    window.pendo.track(eventName, metadata);
  }
};

// Update visitor metadata in Pendo (useful for storing survey responses for segmentation)
export const updatePendoVisitorMetadata = (metadata: Record<string, any>) => {
  if (window.pendo?.updateOptions) {
    window.pendo.updateOptions({
      visitor: metadata,
    });
  }
};

// Show a specific Pendo guide by ID
export const showPendoGuide = (guideId: string) => {
  if (window.pendo?.showGuideById) {
    window.pendo.showGuideById(guideId);
  }
};
